import React, { Component } from 'react';
import { connect } from 'react-redux';
import { localize } from 'react-localize-redux';
import { compose } from 'redux';
import { Field, reduxForm, reset, change, formValueSelector } from 'redux-form';
import { RadioButtonGroup, SelectField } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import FlatButton from 'material-ui/FlatButton';
import { Toggle } from 'redux-form-material-ui';
import MultiFileDropzone from 'components/shared/MultiFileDropzone';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import TextField from 'helpers/reduxFormMaterialUiNext/TextField';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';
import { featureEnabled } from 'helpers/ToggleBot';
import { sortAlphaNum, deepDiver } from 'helpers/utilities';
import { TiPlus as PlusIcon } from 'react-icons/ti';
import { noticeTemplateFormModes } from 'helpers/constants';
import ConfirmationDialog from 'components/shared/ConfirmationDialog';
import { colors } from 'helpers/ColorHelper';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';
import SlideDownAnimation from 'components/shared/SlideDownAnimation';
import {
  LegalNotice,
  NoticeTypes,
  NoticeOfEntryNotice,
  legalNoticeAcceptedFileTypes,
} from './constants';
import MenuItem from 'material-ui/MenuItem';

const styles = {
  sectionHeader: {
    backgroundColor: '#f1f1f1',
    padding: '5px 10px',
    fontSize: '14px',
    fontWeight: '800',
    color: 'rgba(78, 78, 78, 0.6)',
    marginBottom: '10px',
  },
  fieldsRow: {
    marginBottom: '10px',
  },
  savedTemplate: {
    padding: '7px',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
  },
  savedTemplateLast: {
    padding: '7px',
  },
  savedTemplatesWrapper: {
    margin: 'auto',
    maxHeight: '200px',
    overflowY: 'scroll',
    border: '1px solid rgba(0,0,0,0.1)',
  },
  addButton: {
    backgroundColor: 'rgba(0,0,0,0.05)',
    float: 'right',
    color: 'rgba(0,0,0,0.5)',
    minWidth: '75px',
    fontSize: '18px',
    lineHeight: '23px',
  },
  icon: {
    fontSize: '20px',
    position: 'relative',
    top: '-3px',
  },
  deleteIconWrapper: {
    textAlign: 'center',
    paddingTop: '20px',
  },
  emptyList: {
    fontSize: '18px',
    textAlign: 'center',
    padding: '15px',
    color: 'rgba(0,0,0,0.5)',
  },
  imageField: {
    border: `1px dashed ${colors.LIGHT_GRAY}`,
    width: '60%',
    margin: 'auto',
    textAlign: 'center',
  },
  fieldsColBorderBottom: {
    margin: 'auto',
    marginBottom: '15px',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    paddingBottom: '15px',
  },
  radioHeader: {
    fontWeight: '900',
    fontSize: '16px',
    marginTop: 0,
    marginBottom: 0,
  },
};

const config = {
  TOTAL_FILE_SIZE: 15 * 1000000, // 15mb
  IMAGE_SIZE: 3 * 1000000,
};

const CREATE = noticeTemplateFormModes.CREATE;
const UPDATE = noticeTemplateFormModes.UPDATE;

class NoticeTemplateForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedId: null,
      showDeleteConfirmation: false,
    };
  }

  addNewTemplate = () => {
    this.props.changeTemplateFormMode(CREATE);
    this.props.resetForm(this.props.formName);
    this.setState({
      selectedId: null,
    });
  };

  handleCancel = () => {
    this.props.changeTemplateFormMode(null);
    this.props.resetForm(this.props.formName);
    this.setState({
      selectedId: null,
    });
  };

  loadTemplateForEdit = (noticeTemplateId) => {
    this.setState({
      selectedId: noticeTemplateId,
    });

    let noticeTemplate = this.props.noticeTemplates.find(
      (noticeTemplate) => noticeTemplate.id === noticeTemplateId
    );
    if (noticeTemplate) {
      if ([LegalNotice, NoticeOfEntryNotice].includes(noticeTemplate.notice_type)) {
        noticeTemplate.delivery = 'single_unit';
      }
      this.setForm(noticeTemplate);
      this.props.changeTemplateFormMode(UPDATE);
    }
  };

  setForm = (data) => {
    for (let key in data) {
      let value = data[key];
      this.props.changeFormValue(this.props.formName, key, value);
    }
  };

  hideDeleteConfirmation = () => {
    this.setState({
      showDeleteConfirmation: false,
    });
  };

  deleteNoticeTemplate = () => {
    this.props.deleteTemplate(this.state.selectedId).then(() => {
      this.setState({
        showDeleteConfirmation: false,
      });
    });
  };

  render() {
    return (
      <form>
        <SlideDownAnimation>{this._renderSavedTemplates()}</SlideDownAnimation>
        <SlideDownAnimation>{this._renderType()}</SlideDownAnimation>
        <SlideDownAnimation>{this._renderDetails()}</SlideDownAnimation>
        {featureEnabled('notice_restrictions') && (
          <SlideDownAnimation>{this._renderDelivery()}</SlideDownAnimation>
        )}
        {featureEnabled('notice_restrictions') && (
          <SlideDownAnimation>{this._renderAssignment()}</SlideDownAnimation>
        )}
        <SlideDownAnimation>{this._renderAttachment()}</SlideDownAnimation>
        <SlideDownAnimation>{this._renderPhoto()}</SlideDownAnimation>
        <ConfirmationDialog
          showDialog={this.state.showDeleteConfirmation}
          hideDialog={this.hideDeleteConfirmation}
          userConfirmVerbiage={
            this.props.translate('landlordPortal.noticeTemplateForm.delete').props.children
          }
          dialogTitle={
            this.props.translate('landlordPortal.noticeTemplateForm.deleteNoticeTemplate').props
              .children
          }
          dialogBodyVerbiage={
            this.props.translate('landlordPortal.noticeTemplateForm.areYouSure').props.children
          }
          userConfirmAction={this.deleteNoticeTemplate}
        />
      </form>
    );
  }

  _renderSavedTemplates = () => {
    if (this.props.mode !== null) return null;

    return (
      <div>
        {this._renderSavedList()}
        <div className="row" style={styles.fieldsRow}>
          <FlatButton onClick={this.addNewTemplate} style={styles.addButton}>
            <PlusIcon />
          </FlatButton>
        </div>
      </div>
    );
  };

  _renderSavedList = () => {
    if (this.props.noticeTemplates.length === 0) {
      return (
        <div style={styles.emptyList}>
          {this.props.translate('landlordPortal.noticeTemplateForm.noSavedTemplates')}
        </div>
      );
    }
    const sortedTemplates = this.props.noticeTemplates.sort((a, b) =>
      sortAlphaNum(a['label'], b['label'])
    );

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeTemplateForm.savedTemplatesUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={styles.savedTemplatesWrapper}>
            {sortedTemplates.map((noticeTemplate, i) => {
              return (
                <div
                  key={`nt-${noticeTemplate.id}`}
                  style={
                    i === this.props.noticeTemplates.length - 1
                      ? styles.savedTemplateLast
                      : styles.savedTemplate
                  }
                >
                  <span>
                    <button
                      type="button"
                      className="link-button"
                      onClick={() => this.loadTemplateForEdit(noticeTemplate.id)}
                    >
                      {noticeTemplate.name}
                    </button>
                  </span>
                  <span style={{ float: 'right' }}>
                    <button
                      type="button"
                      className="link-button"
                      onClick={() =>
                        this.setState({
                          selectedId: noticeTemplate.id,
                          showDeleteConfirmation: true,
                        })
                      }
                    >
                      {this.props.translate('landlordPortal.noticeTemplateForm.delete')}
                    </button>
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  _renderDetails = () => {
    if (this.props.mode === null) return null;

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.mode === CREATE
                ? this.props.translate('landlordPortal.noticeTemplateForm.createUpcase').props
                    .children
                : this.props.translate('landlordPortal.noticeTemplateForm.updateUpcase').props
                    .children}{' '}
              <button type="button" className="link-button" onClick={this.handleCancel}>
                {this.props.translate('landlordPortal.noticeTemplateForm.cancel')}
              </button>
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ margin: 'auto', marginTop: '10px' }}>
            <Field
              name="name"
              component={TextField}
              label={this.props.translate('landlordPortal.noticeTemplateForm.name').props.children}
              validate={[validator.required]}
            />
          </div>
          <div className="col-xs-12" style={{ margin: 'auto', marginTop: '10px' }}>
            <Field
              name="notice_name"
              component={TextField}
              label={
                this.props.translate('landlordPortal.noticeTemplateForm.noticeTitle').props.children
              }
              validate={[validator.required]}
            />
          </div>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <Field
              name="notice_description"
              multiline
              rows={3}
              component={TextField}
              label={
                this.props.translate('landlordPortal.noticeTemplateForm.noticeDescription').props
                  .children
              }
              validate={[validator.required]}
            />
          </div>
        </div>
      </div>
    );
  };

  _renderAttachment = () => {
    if (this.props.mode === null) return null;
    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeTemplateForm.attachmentUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={styles.fieldsColBorderBottom}>
            <p>
              {this.props.translate('landlordPortal.noticeTemplateForm.ifYouWouldLikeToAttach')}
            </p>
            <Field
              name="attachments"
              component={MultiFileDropzone}
              acceptedFileTypes={legalNoticeAcceptedFileTypes}
              maxTotalFileSize={config.TOTAL_FILE_SIZE}
              multiple
              changeFormValue={this.props.changeFormValue}
              formName={this.props.form}
            >
              <p style={{ color: colors.BLUE, textAlign: 'center' }}>
                {this.props.translate('landlordPortal.noticeTemplateForm.clickToAddAttachment')}
              </p>
            </Field>
          </div>
        </div>

        {featureEnabled('notice_restrictions') && (
          <div className="row" style={styles.fieldsRow}>
            <div className="col-xs-12">
              <Field
                name="allow_attachment_modify"
                type="toggle"
                component={Toggle}
                label={
                  <p style={styles.radioHeader}>
                    {this.props.translate('landlordPortal.noticeTemplateForm.attachmentModify')}
                  </p>
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  isLegalNotice = () => {
    return this.props.noticeType === LegalNotice;
  };

  isNoticeOfEntryNotice = () => {
    return this.props.noticeType === NoticeOfEntryNotice;
  };

  _renderDelivery = () => {
    const { mode } = this.props;
    if (mode === null) return null;

    const restrictedNotice = this.isLegalNotice() || this.isNoticeOfEntryNotice();
    const radioTextStyle = restrictedNotice ? { color: colors.DISABLED_GRAY } : {};

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeTemplateForm.deliveryUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <p>{this.props.translate('landlordPortal.noticeTemplateForm.delivery')}</p>
            <div className="col-sm-12" style={{ margin: '15px 0' }}>
              <Field name="delivery" component={RadioButtonGroup}>
                <RadioButton
                  value="any"
                  disabled={restrictedNotice}
                  label={
                    <span style={radioTextStyle}>
                      <p style={styles.radioHeader}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.any')}
                      </p>
                      <p style={{ marginTop: 0 }}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.anySub')}
                      </p>
                    </span>
                  }
                />
                <RadioButton
                  value="single_property"
                  disabled={restrictedNotice}
                  label={
                    <span style={radioTextStyle}>
                      <p style={styles.radioHeader}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.property')}
                      </p>
                      <p style={{ marginTop: 0 }}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.propertySub')}
                      </p>
                    </span>
                  }
                />
                <RadioButton
                  value="single_unit"
                  label={
                    <span>
                      <p style={styles.radioHeader}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.unit')}
                      </p>
                      <p style={{ marginTop: 0 }}>
                        {this.props.translate('landlordPortal.noticeTemplateForm.unitSub')}
                      </p>
                    </span>
                  }
                />
              </Field>
              <Field name="delivery" component={formatter.RenderError} />
            </div>
          </div>
        </div>
      </div>
    );
  };

  propertyOptions = () => {
    const { properties } = this.props;

    if (this.isLegalNotice()) {
      return properties.filter((p) => !!p.can_send_legal_notices);
    } else {
      return properties;
    }
  };

  _renderAssignment = () => {
    if (this.props.mode === null) return null;

    const allPropertiesLabel = this.isLegalNotice()
      ? 'landlordPortal.noticeTemplateForm.assignmentAllLegal'
      : 'landlordPortal.noticeTemplateForm.assignmentAll';

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeTemplateForm.assignmentUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            <p>{this.props.translate('landlordPortal.noticeTemplateForm.assignment')}</p>
            <div className="col-sm-12" style={{ margin: '15px 0' }}>
              <Field
                name="assign_to_properties"
                component={RadioButtonGroup}
                parse={(value) => value === 'true'}
                format={(value) => {
                  if (value === undefined || value === null) return;

                  return value ? 'true' : 'false';
                }}
                onChange={(event) => {
                  if (this.props.onUpdate) {
                    this.props.onUpdate(event.target.value === 'true');
                  }
                }}
              >
                <RadioButton
                  value="false"
                  label={
                    <p style={styles.radioHeader}>{this.props.translate(allPropertiesLabel)}</p>
                  }
                />
                <RadioButton
                  value="true"
                  label={
                    <p style={styles.radioHeader}>
                      {this.props.translate('landlordPortal.noticeTemplateForm.assignmentSpecific')}
                    </p>
                  }
                />
              </Field>
              {this.props.assignToProperties && (
                <div style={{ marginTop: '10px' }}>
                  <Field
                    name="properties"
                    data={this.propertyOptions()}
                    component={MultiSelectExtended}
                    multiple
                    hintText={
                      this.props.translate('landlordPortal.noticeAssignmentForm.properties').props
                        .children
                    }
                    innerDivStyle={{
                      width: '100%',
                      fontSize: '15px',
                      fontWeight: '100 !important',
                    }}
                    menuStyle={{ minWidth: '250px', fontSize: '15px' }}
                    style={{ fontSize: '15px' }}
                    fullWidth
                    validate={[validator.required]}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // legal document notice type means we can only deliver
  // to single unit
  handleTypeChanged = (ev, selection) => {
    if ([LegalNotice, NoticeOfEntryNotice].includes(selection)) {
      this.setForm({ delivery: 'single_unit' });
    }
  };

  _renderType = () => {
    const { legalNoticesEnabled, mode, translate } = this.props;
    if (mode === null) return null;

    const noticeTypes = () => {
      let types = NoticeTypes;
      if (!legalNoticesEnabled) {
        types = types.filter((t) => t.value !== LegalNotice);
      }

      if (!featureEnabled('notice_of_entry_as_notices')) {
        types = types.filter((t) => t.value !== NoticeOfEntryNotice);
      }

      return types;
    };

    const renderSelect = () => {
      return (
        <Field
          name="notice_type"
          component={SelectField}
          onChange={this.handleTypeChanged}
          validate={[validator.required]}
          floatingLabelText={translate('landlordPortal.noticeTemplateForm.type')}
          fullWidth
          style={{
            marginTop: '-15px',
            fontSize: '15px',
            textAlign: 'left',
            width: '100%',
          }}
        >
          {noticeTypes().map((type) => (
            <MenuItem value={type.value} key={type.value} primaryText={type.label} />
          ))}
        </Field>
      );
    };

    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {translate('landlordPortal.noticeTemplateForm.typeUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={{ marginTop: '10px' }}>
            {renderSelect()}
          </div>
        </div>
      </div>
    );
  };

  _renderPhoto = () => {
    if (this.props.mode === null) return null;
    return (
      <div>
        <div className="row" style={styles.sectionHeader}>
          <div className="col-xs-12">
            <p style={{ margin: '0', textAlign: 'center' }}>
              {this.props.translate('landlordPortal.noticeTemplateForm.photoUpcase')}
            </p>
          </div>
        </div>

        <div className="row" style={styles.fieldsRow}>
          <div className="col-xs-12" style={styles.fieldsColBorderBottom}>
            <p>{this.props.translate('landlordPortal.noticeTemplateForm.ifYouWouldLikeToDraw')}</p>
            <Field
              name="notice_image"
              style={styles.imageField}
              labelText={this.props.translate('landlordPortal.noticeTemplateForm.clickToAddPhoto')}
              component={ReduxDropzone}
              viewFileLink
              fileValidation=".jpeg, .png, .jpg"
              size={120}
              multiple={false}
              maxFileSize={config.IMAGE_SIZE}
            />
          </div>
        </div>

        {featureEnabled('notice_restrictions') && (
          <div className="row" style={styles.fieldsRow}>
            <div className="col-xs-12">
              <Field
                name="allow_image_modify"
                type="toggle"
                component={Toggle}
                label={
                  <p style={styles.radioHeader}>
                    {this.props.translate('landlordPortal.noticeTemplateForm.photoModify')}
                  </p>
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  };
}

let ConnectedNoticeTemplateForm = compose(
  connect(
    (state, ownProps) => {
      return {
        form: ownProps.formName,
        properties: state.landlordProperties.properties,
        selectedProperties: formValueSelector(ownProps.formName)(state, 'properties'),
        assignToProperties: formValueSelector(ownProps.formName)(state, 'assign_to_properties'),
        attachments: deepDiver(state, `form.${ownProps.formName}.values.attachments`),
        noticeType: formValueSelector(ownProps.formName)(state, 'notice_type'),
        legalNoticesEnabled:
          featureEnabled('legal_documents_as_notices') &&
          !!state.companyDetails.companyPreferences.enable_tenant_legal_notices,
      };
    },
    {
      resetForm: reset,
      changeFormValue: change,
    }
  ),
  reduxForm({
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
    initialValues: {
      notice_type: null,
      delivery: 'any',
      assign_to_properties: false,
      allow_attachment_modify: true,
      allow_image_modify: true,
      attachments: [],
    },
  })
)(localize()(NoticeTemplateForm));

export default ConnectedNoticeTemplateForm;
